import * as React from 'react';
import styled from 'styled-components';
import { NeutralColors } from '../../common/colors';

interface ClusterButtonProps {
  active: boolean;
  icon: JSX.Element;
  handleClick: () => void;
}

const CTAWrapper = styled.div<{ active: boolean }>`
  button {
    color: ${({ active }) => active && NeutralColors.White};
  }
`;

const ClusterButtonItem = styled.button`
  border: none;
  border-radius: 100%;
  background-color: transparent;
  color: ${NeutralColors.OffWhite};
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${NeutralColors.LightGray};
  }
`;

export const ClusterButton = ({
  active,
  icon,
  handleClick,
  ...rest
}: ClusterButtonProps): JSX.Element => {
  return (
    <CTAWrapper active={active}>
      <ClusterButtonItem type="button" onClick={handleClick} {...rest}>
        {icon}
      </ClusterButtonItem>
    </CTAWrapper>
  );
};
